// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.device_channel_datatype_enum */
var DeviceChannelDatatypeEnum;
(function (DeviceChannelDatatypeEnum) {
    DeviceChannelDatatypeEnum["NUMERIC"] = "NUMERIC";
    DeviceChannelDatatypeEnum["BOOLEAN"] = "BOOLEAN";
})(DeviceChannelDatatypeEnum || (DeviceChannelDatatypeEnum = {}));
;
export default DeviceChannelDatatypeEnum;
/** Zod schema for device_channel_datatype_enum */
export const deviceChannelDatatypeEnum = z.nativeEnum(DeviceChannelDatatypeEnum);
//# sourceMappingURL=DeviceChannelDatatypeEnum.js.map